import React, { useState, useEffect } from 'react'
import { API_URL } from '../settings'
import { useAuth } from '../Hooks/useAuth'
import axios from 'axios'
import styles from "./Components/PostUsers.module.css"

const CurrentSignatureComponent = ({ email, setCurrentEmail }) => {
    const storedUser = useAuth() // Retrieve user token from local storage
    const [ user, setUser ] = useState()
    const createMarkup = user => ({__html: user}) 

    useEffect(() => {
        axios.get(`${API_URL}/users/user-email-data/${email}`, { headers: { token: storedUser.user.data.token}}).then(res => setUser(res.data)).then(error => console.log(error))
    }, [])
  
    if (user) {
        return (
            <div className={styles.modal}>
                <div className={styles.modalContent} style={{overflow:"hidden"}}>
                    <span className={styles.close} onClick={() => setCurrentEmail(false)}>&times;</span>
                    <h2 className={styles.modalTitle}>Current Signature Stored in Gmail</h2>
                    <div style={{padding:"5rem"}}>
                        {
                            user.data.signature.length > 0 ? 
                                <div dangerouslySetInnerHTML={ createMarkup(user.data.signature) } /> : 
                                <h2 className={styles.noDataTitle}>No data in signature</h2>
                        }
                    </div>
                </div>
            </div>
        )
    } 
}
export default CurrentSignatureComponent;